import React from "react";
import PropTypes from "prop-types";
import DetailsModal from "./DetailsModal";
import TopNavigation from "./TopNavigation";

const IframeView = ({ src, title, height }) => {
    return (

        <div className="mx-auto">
            <div className=" min-h-screen bg-slate-50 dark:bg-slate-900 text-slate-900 dark:text-slate-100 font-sans p-4 md:p-8 transition-colors duration-200">

                {/* Modal */}

                <TopNavigation />
                <div className={'iframe-wrapper'}
>               <iframe
                    src={'/admin/queues/WEB/queue/WEB-searchable?status=failed'}
                    title={title}
                    loading="lazy"
                    allowFullScreen
                    referrerPolicy="no-referrer"
                    style={{
                        width: "100%",
                        height: height || "100%",
                        border: "none",
                    }}
                />
                </div>

            </div>
        </div>
    );
};

IframeView.propTypes = {
    src: PropTypes.string.isRequired,
    title: PropTypes.string,
    height: PropTypes.string,
};

IframeView.defaultProps = {
    title: "Embedded View",
};

export default IframeView;